import React, { useEffect, useState } from "react";
import bwipjs from '../../../../node_modules/bwip-js/dist/bwip-js';

interface BarCodeGeneratorProps {
  input: string,
  barCodeType: string
}

export default function BarCodeGenerator({ input, barCodeType }: BarCodeGeneratorProps) {


  function createImageSrc(){
    let canvas = document.createElement("canvas");
    bwipjs.toCanvas(canvas, {
      bcid: barCodeType,
      text: input,
      scale: 4,
      height: 7,
      includetext: false,
      textxalign: "center"
    });
    return canvas.toDataURL("image/png")
  }

  return (
    <div>
        <img src={createImageSrc()} 
        alt={`data matrix from ${input}`} />
      </div>
  );
}
